export const BLEED_INCHES = 0.125

// Fallback Cloud Render output resolution when a product has no Output DPI set
// in Sanity. The render pixelRatio is the target output DPI divided by the
// design's own DPI.
export const DEFAULT_OUTPUT_DPI = 600

// Matrix code zone: a 5.5mm reserved square. The only hard definition — consumers
// convert to px against the document's own px/inch at runtime.
export const MATRIX_CODE_MM = 5.5

// The matrix-code square edge in inches — same square as MATRIX_CODE_MM, handy
// when converting a bottom-left anchor point to a top-left bounding-box origin.
export const MATRIX_CODE_INCHES = MATRIX_CODE_MM / 25.4

// Die-cut (rounded-corner) label geometry — LEGACY AAV9 fallbacks. These are now
// authored per label size in Sanity (`usesDieCut` + `cornerRadiusInches` +
// `safeCornerRadiusInches`); the constants below are only used when a label size
// has no die-cut config yet, gated by the AAV9 SKU prefix. The trim line and
// bleed mask trace the physical die cut; the safe area uses a slightly tighter
// radius so it curves just inside the cut. In inches; converted to px at runtime.
export const AAV9_LABEL_CORNER_RADIUS_INCHES = 0.4
export const AAV9_SAFE_AREA_CORNER_RADIUS_INCHES = 0.36

// Fixed matrix-code position for AAV9 SKUs — LEGACY fallback, read from the
// Illustrator source file (top-left of the code's bounding box). The .ai artboard
// origin is the top-left of the BLEED, so consumers subtract the bleed margin to
// get trim-relative coords (verified against the client's reference mockup —
// matches to ~0.02in). Superseded by Sanity `matrixCoordinateX/Y` (bottom-left
// origin) for all products; used only when those coords are absent.
export const AAV9_MATRIX_CODE_X_INCHES = 0.5581
export const AAV9_MATRIX_CODE_Y_INCHES = 2.2792
